"use client";

import { useId, useState } from "react";
import { PasswordInput } from "@/components/forms/PasswordInput";
import { RegistrationConsentPreview, RegistrationInformationNotice } from "@/features/service-information/RegistrationConsent";
import { SuppliedOnboardingDocuments } from "./SuppliedOnboardingDocuments";
import type { SuppliedConsentChoices } from "../supplied-documents";

// Free browsing keeps field values in memory and never calls registration APIs.
export function RegistrationAccountPreview({ onContinue, creator = false, onSensitiveSigned }: { onContinue: () => void; creator?: boolean; onSensitiveSigned?: (choices: SuppliedConsentChoices) => void }) {
  const id = useId();
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [choices, setChoices] = useState<SuppliedConsentChoices>();

  return <div className="rg-form rg-registration-form">
    <div className="rg-field">
      <div className="rg-field-heading"><label htmlFor={`${id}-phone`}>手机号<span className="rg-required">*</span></label></div>
      <input id={`${id}-phone`} aria-label="注册手机号" type="tel" inputMode="numeric" autoComplete="off" maxLength={11} placeholder="请输入 11 位手机号" value={phone} onChange={event => setPhone(event.target.value.replace(/\D/g, ""))} />
    </div>
    <label className="rg-field">
      <span>短信验证码<span className="rg-required">*</span></span>
      <span className="rg-code-row">
        <input aria-label="短信验证码" type="text" inputMode="numeric" autoComplete="off" maxLength={6} placeholder="请输入 6 位验证码" value={code} onChange={event => setCode(event.target.value.replace(/\D/g, ""))} />
        <button type="button" className="rg-send" disabled title="自由查看不发送短信验证码">发送验证码</button>
      </span>
    </label>
    <div className="rg-field">
      <label htmlFor={`${id}-password`}>设置密码<span className="rg-required">*</span></label>
      <PasswordInput id={`${id}-password`} className="rg-password-input" autoComplete="new-password" maxLength={200} placeholder="至少 10 个字符" value={password} onChange={event => setPassword(event.target.value)} />
    </div>
    <RegistrationConsentPreview>
      {creator && <SuppliedOnboardingDocuments role="creator" signed={{ sensitive: Boolean(choices) }} choices={choices} sensitiveOnly onSign={async (_id, value) => { if (value) { setChoices(value); onSensitiveSigned?.(value); } }} />}
    </RegistrationConsentPreview>
    <div className="rg-actions"><button type="button" className="rg-primary" onClick={onContinue}>下一步</button></div>
    <RegistrationInformationNotice />
  </div>;
}
